/* eslint-disable no-console */
// Web-safe mock for react-native-onetrust-cmp
// Provides consent management functionality for web

const OTPublishersNativeSDK = {
  startSDK: (
    storageLocation,
    domainIdentifier,
    languageCode,
    options,
    showBanner,
  ) => {
    // Mock successful initialization
    // For web, options might be the callback, or showBanner might be callback
    const callback =
      typeof options === 'function'
        ? options
        : typeof showBanner === 'function'
        ? showBanner
        : null;

    if (callback) {
      callback(true);
    }
    return Promise.resolve(true);
  },

  stopSDK: () => {
    // Mock successful stop
    return Promise.resolve(true);
  },

  getConsentStatusForSDKId: sdkId => {
    // Mock consent granted for all SDKs on web
    return Promise.resolve(1); // 1 = consented
  },

  getOTConsentStatus: () => {
    // Mock consent status
    return Promise.resolve({
      consentStatus: true,
      consentString: 'mock-consent-string',
    });
  },

  listenForConsentChanges: (sdkId, callback) => {
    // Mock no consent changes
    if (callback) {
      callback(1); // 1 = consented
    }
    return Promise.resolve(true);
  },

  queryConsentStatus: (sdkIds, callback) => {
    // Mock consent granted for all SDKs
    const result = {};
    sdkIds.forEach(id => {
      result[id] = 1; // 1 = consented
    });
    if (callback) {
      callback(result);
    }
    return Promise.resolve(result);
  },

  showConsentUI: () => {
    // Mock showing consent UI (no-op on web)
    return Promise.resolve(true);
  },

  getDomainGroupId: () => {
    // Mock domain group ID
    return Promise.resolve('mock-domain-group-id');
  },

  getDomainId: () => {
    // Mock domain ID
    return Promise.resolve('mock-domain-id');
  },

  setBroadcastAllowedValues: categories => {
    // Mock setting allowed broadcast values for SDK categories
    console.log('OneTrust: Set broadcast allowed values', categories);
    return Promise.resolve(true);
  },
};

export default OTPublishersNativeSDK;
